import DirectToVdpContext from 'contexts/DirectToVdpContext';
import React, { useEffect, useRef, PropsWithChildren, useContext } from 'react';

export type VdpScrollContainerProps = PropsWithChildren<unknown>;

// the VdpScrollContainer initializes the VDP scroll-position to the top of the page via `position: fixed`
// this is needed because the VDP component is swapped with the SRP, all within the same page. Without this
// initialization from VdpScrollContainer, the VDP scroll position will adopt the SRP's scroll position.
export function VdpScrollContainer(props: VdpScrollContainerProps): JSX.Element {
  const vdpScrollContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (vdpScrollContainerRef.current) {
      vdpScrollContainerRef.current.classList.remove('vdp-scroll-container');
    }
  }, []);

  const { isDirectToVdp } = useContext(DirectToVdpContext);

  return (
    <>
      <div
        className="vdp-scroll-container"
        data-testid="vdp-scroll-container"
        id="vdp-scroll-container"
        ref={vdpScrollContainerRef}
      >
        {props.children}
      </div>
      <style jsx>
        {`
          .vdp-scroll-container {
            position: ${isDirectToVdp ? '' : 'fixed'};
          }
        `}
      </style>
    </>
  );
}
